import React from 'react';
import { ISimpleComponent, IGrid } from './interface';
import { GridStyles } from './styles';
import './styles.scss';

export const Column: React.FC<ISimpleComponent> = (props) => {
  const {
    children,
    className,
    tabIndex,
    style,
    onFocus,
    onBlur,
    onClick,
    id
  } = props;

  return (
    <>
      <div
        id={id}
        tabIndex={tabIndex || undefined}
        onFocus={onFocus || undefined}
        onBlur={onBlur || undefined}
        onClick={onClick || undefined}
        className={`d-flex flex-column ${className ?? ''}`}
        style={style || {}}
        role="presentation"
      >
        {children}
      </div>
    </>

  );
};
/**
 * Create a div flex row.
 * @param {*} Row:
 */
export const Row: React.FC<ISimpleComponent> = (props) => {
  const {
    children,
    className,
    tabIndex,
    style,
    onFocus,
    onBlur,
    onClick,
    id
  } = props;

  return (
    <>
      <div
        id={id}
        tabIndex={tabIndex || undefined}
        onFocus={onFocus || undefined}
        onBlur={onBlur || undefined}
        onClick={onClick || undefined}
        className={`d-flex ${className ?? ''}`}
        style={style || {}}
        role="presentation"
      >
        {children}
      </div>
    </>

  );
};

export const Grid: React.FC<IGrid> = (props) => {
  const { children, className, tabIndex, style, id, onClick, ...rest } = props;

  return (
    <GridStyles
      id={id}
      tabIndex={tabIndex || undefined}
      onClick={onClick || undefined}
      className={`${className || ''}`}
      style={style || {}}
      {...rest}
    >
      {children}
    </GridStyles>
  );
};
